import React, { createContext, useState } from 'react';

export const ThemeContext = createContext();

const ThemeProvider = (props) => {
    const [theme, setTheme] = useState(localStorage.getItem("quotationTheme") != null ? localStorage.getItem("quotationTheme") : "default");

    const ClickThemeMode = (themeColor) => {
        localStorage.setItem("quotationTheme", themeColor);
        setTheme(themeColor);
    };

    const themeContextData = {
        themeClick: ClickThemeMode,
        CurrentTheme: theme
    };

    return (<ThemeContext.Provider value={themeContextData} {...props}></ThemeContext.Provider>)
};

export default ThemeProvider;